export default __webpack_public_path__ + "static/media/img-7.ef578c67.jpg";